import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from './../services/storage.service';

export const authGuard: CanActivateFn = (route, state) => {
  const storageservice : StorageService = inject(StorageService);
  const router         : Router = inject(Router);
  let user = storageservice.retrieve('isAuthTokenRequired');
  if(user) return true;
  router.navigateByUrl('/account/login');
  return false;
};